<footer class="mh-footer mh-footer-3" id="rdm-contact">
    <div class="container-fluid">
        <div class="row section-separator">
            <div class="col-sm-12 section-title wow fadeInUp"
                data-wow-duration="0.8s" data-wow-delay="0.2s">
                <h3>Contato</h3>
            </div>
            <div class="map-image image-bg col-sm-12">
                <div class="container mt-30">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mh-footer-address">
                            <div class="col-sm-12 xs-no-padding">
                                <div class="mh-address-footer-item media dark-bg
                                    shadow-1 wow fadeInUp"
                                    data-wow-duration="0.8s"
                                    data-wow-delay="0.2s">
                                    <div class="each-icon">
                                        <i class="fa fa-envelope-o"></i>
                                    </div>
                                    <div class="each-info media-body">
                                        <h4>E-mail</h4>
                                        <a href="mailto:raynner@outlook.com">raynner&#64;outlook.com</a><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mh-footer-address">
                            <div class="col-sm-12 xs-no-padding">
                                <div class="mh-address-footer-item media dark-bg
                                    shadow-1 wow fadeInUp"
                                    data-wow-duration="0.8s"
                                    data-wow-delay="0.4s">
                                    <div class="each-icon">
                                        <i class="fa fa-phone"></i>
                                    </div>
                                    <div class="each-info media-body">
                                        <h4>Telefone</h4>
                                        <a href="callto:+55 (11) 99349-8646">+55
                                            (11) 99349-8646</a><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 mh-copyright wow fadeInUp"
                            data-wow-duration="0.8s" data-wow-delay="0.2s">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="text-left text-xs-center">
                                        <p>Todos os direitos reservados. RDM &#64; {{getYear()}}</p>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <ul class="social-icon">
                                        <li>
                                            <a href="https://medium.com/@raynnerdm" target="_blank">
                                                <i class="fa fa-medium"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://github.com/raynnerdm" target="_blank">
                                                <i class="fa fa-github"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/in/raynnerdm/" target="_blank">
                                                <i class="fa fa-linkedin"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://www.facebook.com/raynnerdm" target="_blank">
                                                <i class="fa fa-facebook"></i></a></li>
                                        <li>
                                            <a href="https://www.instagram.com/raynnerdm" target="_blank">
                                                <i class="fa fa-instagram"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>